import { render } from "./AppDashboardOverviewSkeleton.vue?vue&type=template&id=445ddc96&scoped=true"
const script = {}

import "./AppDashboardOverviewSkeleton.vue?vue&type=style&index=0&id=445ddc96&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445ddc96"]])

export default __exports__